import { z } from 'zod';
import { annotationPartnerZod } from 'packages/lib/api/annotations/contract/enums';

export const lidarAnnotationZod = z.object({
  token: z.string(),
  objectToken: z.string(),
  sampleToken: z.string(),
  partner: annotationPartnerZod.optional(),
  x: z.number(),
  y: z.number(),
  z: z.number(),
  width: z.number(),
  length: z.number(),
  height: z.number(),
  roll: z.number(),
  pitch: z.number(),
  yaw: z.number(),
  name: z.string().nullable(),
  taskToken: z.string().nullable(),
  instructionToken: z.string().nullable(),
  attributes: z.string().nullable(),
  visibility: z.string().nullable(),
  tag: z.string().nullable(),
  comment: z.string().nullable(),
  className: z.string().nullable(),
});
export const lidarAnnotationRespZod = z.array(lidarAnnotationZod);
export type LidarAnnotation = z.infer<typeof lidarAnnotationZod>;
export type LidarAnnotationResp = z.infer<typeof lidarAnnotationRespZod>;

// Use this for saving annotations
export const lidarsegAnnotationMetadataZod = z.object({
  name: z.string().nonempty(),
  sampleToken: z.string().nonempty(),
  taskToken: z.string().nonempty(),
  instructionToken: z.string().nonempty(),
  partner: annotationPartnerZod.optional().default('None'),
  comment: z.string().optional().default(''),
});

export type LidarSegAnnotationMetadata = z.infer<
  typeof lidarsegAnnotationMetadataZod
>;

export const lidarsegAnnotationMetadataRespZod = z.object({
  token: z.string(),
});

export type LidarsegAnnotationMetadataResp = z.infer<
  typeof lidarsegAnnotationMetadataRespZod
>;

export const savedLidarsegAnnotationMetadataZod = z.object({
  name: z.string(),
  sampleToken: z.string(),
  taskToken: z.string(),
  instructionToken: z.string(),
  partner: annotationPartnerZod.optional().default('None'),
  comment: z.string().optional().default(''),
});

const LidarSegAnnotationZod = savedLidarsegAnnotationMetadataZod.extend({
  token: z.string().nonempty(),
});

export const LidarsegAnnotationsResponseZod = LidarSegAnnotationZod.array();
export type LidarSegAnnotationsResponse = z.infer<
  typeof LidarsegAnnotationsResponseZod
>;
